import { initializeApp, getApps, getApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore, initializeFirestore, Timestamp, serverTimestamp } from "firebase/firestore";
import { getFunctions } from "firebase/functions";
import { getStorage } from "firebase/storage";
import { installFirestoreRulesDiagnostics } from "../services/firestoreRulesDiagnosticsService";
import { installPermissionDoctor } from "../services/permissionDoctorService";

import { firebaseConfig, functionsRegion } from "./runtimeConfig.ts";

const app = getApps().length ? getApp() : initializeApp(firebaseConfig);

export const auth = getAuth(app);

declare global {
  interface Window {
    __mintleafGetIdToken?: () => Promise<string | null>;
  }
}

const MINTLEAF_PAGES_PREVIEW_HOST_PATTERN = /^[a-z0-9-]+\.mintleaf-foglalasok-4-ai-copy\.pages\.dev$/i;

const isMintleafAuthDebugHost = (): boolean => {
  if (typeof window === 'undefined') return false;
  return Boolean(import.meta.env.DEV) || MINTLEAF_PAGES_PREVIEW_HOST_PATTERN.test(window.location.hostname);
};

const installMintleafAuthDebugHelper = (): void => {
  if (!isMintleafAuthDebugHost()) return;
  window.__mintleafGetIdToken = async () => auth.currentUser?.getIdToken() ?? null;
  console.info('[mintleaf.debug] __mintleafGetIdToken available');
};

installMintleafAuthDebugHelper();
const isDev = process.env.NODE_ENV !== "production";
export const db = isDev
  // Dev-only long polling helps CloudShell/proxy/mobile environments avoid transport aborts.
  ? initializeFirestore(app, { experimentalForceLongPolling: true })
  : getFirestore(app);
export const functions = getFunctions(app, functionsRegion);

// ✅ csak egyszer exportáld, explicit bucket URL-lel
export const storage = getStorage(app, "gs://mintleaf-74d27.firebasestorage.app");

if (isDev) {
  installFirestoreRulesDiagnostics(auth, db);
}
installPermissionDoctor(auth, db);

export { Timestamp, serverTimestamp };
